import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getUsers } from "@sourcewhale/shared/src/svelte/api/users";
import { getTeam } from "../api/admin";

export const usersStore = SwApiStore({
  get: getUsers,
  cacheKey: "license-users",
});

export const teamStore = SwApiStore({
  get: (...args) => getTeam({}, ...args),
  onMessage: ({ message, get }) => {
    if (message.kind === "teamLicenseUpdated") {
      get();
    }
  },
});
